import { updatelayoutAdsData } from 'helpers/ads/revenueRedux';
import { createSlug, getSiteDomain, randomNum } from '../../utils/common';
import makeRequest from '../../utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { TOI_LIVE_DOMAIN } from '../../constants';
import {
  getSortedViewDataForSingleState,
  getSortedViewDataForStates,
} from './utils/computation';

const reducerName = 'usElection';
const createActionName = name => `toi/${reducerName}/${name}`;

const ELECTION_CONTENT_FEED_PATH =
  '/homepage_us_election_feed/msid-114210052,feedtype-sjson.cms';

export const RECEIVE_ELECTION_DATA = createActionName('RECEIVE_ELECTION_DATA');
export const RECEIVE_ELECTION_RESULT_DATA = createActionName(
  'RECEIVE_ELECTION_RESULT_DATA',
);
export const HANDLE_ELECTION_DATA_ERROR = createActionName(
  'HANDLE_ELECTION_DATA_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');
export const RECEIVE_FILTER_DATA = createActionName('RECEIVE_FILTER_DATA');

export const DATA_LOADED = createActionName('DATA_LOADED');

function receiveElectionData(data) {
  return {
    type: RECEIVE_ELECTION_DATA,
    payload: data,
  };
}

function receiveElectionResultData(data) {
  return {
    type: RECEIVE_ELECTION_RESULT_DATA,
    payload: data,
  };
}

export function recieveFilterData(data) {
  return {
    type: RECEIVE_FILTER_DATA,
    payload: data,
  };
}

function handleElectionDataError() {
  return {
    type: HANDLE_ELECTION_DATA_ERROR,
    payload: {},
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

// function fetchDataFromUrl(url) {
//   return makeRequest.get(url, 'skipfeedengine');
// }

async function fetchElectionData(data = null, feedUrl, web) {
  const requestParams = {
    params: {},
  };
  let response = data ? { data } : null;
  if (!response) {
    const feedPath = web ? `${feedUrl}?pfm=web` : feedUrl;
    const url = feedPath;
    response = await makeRequest.get(url, requestParams, 'skipfeedengine');
  }
  if (response?.data?.result?.scores?.url) {
    const scores = await makeRequest.get(
      `${response.data.result.scores.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    response.data.result.scores.data = scores.data;
  }
  return response;
}

async function fetchResultData(exitPollResultObject) {
  const requestParams = {
    params: {},
  };
  const result = await makeRequest.get(
    `${exitPollResultObject.result.url}?t=${randomNum()}`,
    requestParams,
    'skipfeedengine',
  );
  exitPollResultObject.result.data = result.data;
  return exitPollResultObject;
}

export function filterSearchSortData(searches = [], loader = false) {
  return dispatch => {
    if (loader) dispatch(dataLoading());
    dispatch(recieveFilterData({ searches, loader }));
    if (loader) dispatch(dataLoaded());
  };
}

export function loadUSElectionData(
  data = null,
  url = `${getSiteDomain()}${ELECTION_CONTENT_FEED_PATH}`,
  web = true,
) {
  return dispatch =>
    // dispatch(dataLoading());
    fetchElectionData(data, url, web)
      .then(response => {
        // dispatch(dataLoaded());
        dispatch(receiveElectionData(response.data));
        if (typeof window === 'undefined' && response?.data?.ads) {
          dispatch(updatelayoutAdsData(response.data.ads));
        }
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleElectionDataError(error));
      });
}

export function loadResult(exitPollObject, loader = false) {
  return dispatch => {
    if (loader) {
      dispatch(dataLoading());
    }
    return fetchResultData(exitPollObject)
      .then(response => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(receiveElectionResultData(response));
      })
      .catch(error => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(handleElectionDataError(error));
      });
  };
}

export const arrayToHashMap = (arr, key = 'an') => {
  const hashMap = {};
  if (arr && Array.isArray(arr)) {
    arr.forEach(item => {
      if (item?.[key] && !hashMap?.[item[key]]) {
        hashMap[item[key]] = item;
      }
    });
  }

  return hashMap;
};

export const compareElectWon = (a, b) => b.electWon - a.electWon;

const getLeadWonCandidate = (data, majority) => {
  let leadingPartyObj = {};
  if (
    data?.starCandidates &&
    Array.isArray(data.starCandidates) &&
    data.starCandidates.length > 1
  ) {
    const sortedPartyData = data.starCandidates.sort(compareElectWon);
    const [
      firstPartyData = { electWon: 0 },
      secondPartyData = { electWon: 0 },
    ] = [...sortedPartyData];

    const firstPartyElectWon = firstPartyData?.electWon || 0;
    const secondPartyElectWon = secondPartyData?.electWon || 0;

    if (firstPartyElectWon >= majority && firstPartyData?.winner === 'X') {
      //First party WON
      leadingPartyObj = {
        party: `${firstPartyData?.first || ''} ${firstPartyData?.last || ''}`,
        text: 'WON',
      };
    } else if (
      firstPartyElectWon > majority ||
      firstPartyElectWon > secondPartyElectWon
    ) {
      leadingPartyObj = {
        party: `${firstPartyData?.first || ''} ${firstPartyData?.last || ''}`,
        text: 'LEADING',
      };
    }
  }
  return leadingPartyObj;
};

function getSortedAndSearchData({ data, searches = [] }) {
  if (!(data && Array.isArray(data))) {
    return null;
  }
  searches = searches
    ? Object.entries(searches).map(([key, value]) => ({ key, value }))
    : [];

  if (searches && Array.isArray(searches) && searches.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const search of searches) {
      if (search.value) {
        // eslint-disable-next-line no-loop-func
        data = data.filter(item => {
          if (
            search.key &&
            typeof search.key === 'string' &&
            search.key.includes('#')
          ) {
            const orConditions = search.key.split('#');
            return orConditions.some(
              condition =>
                item[condition] &&
                createSlug(item[condition]).includes(createSlug(search.value)),
            );
          }
          if (!isNaN(item[search.key])) {
            return item[search.key] === search.value;
          }
          return (
            item[search.key] &&
            createSlug(item[search.key]).includes(createSlug(search.value))
          );
        });
      }
    }
  }
  return data;
}

export const getMajorityCount = (disableSeatCount, ttl_seat) =>
  disableSeatCount
    ? Math.floor((ttl_seat - disableSeatCount) / 2) + 1
    : Math.floor(ttl_seat / 2) + 1;

const getSortedViewDataForUS = (data, states, searches = null) => {
  const usData = data || {};
  usData.nation = usData?.nation || {};
  usData.nation.majority = getMajorityCount(0, usData?.nation?.electTotal || 0);
  usData.nation.totalWonSeats =
    usData?.nation?.candidates && Array.isArray(usData.nation.candidates)
      ? usData.nation.candidates.reduce((total, partyData) => ({
          electWon: (total?.electWon || 0) + (partyData?.electWon || 0),
        }))
      : {};
  usData.nation.leadingPartyObj = getLeadWonCandidate(
    usData?.nation,
    usData.nation.majority,
  );

  usData.nation.starCandidates =
    data?.nation?.starCandidates && Array.isArray(data.nation.starCandidates)
      ? arrayToHashMap(data.nation.starCandidates, 'first')
      : {};
  usData.states =
    data.states &&
    Array.isArray(data.states) &&
    data.states.length > 0 &&
    data.states.map(state => {
      let stateInfo =
        states && Array.isArray(states)
          ? states.filter(st => st.key === state.statePostal)
          : [];
      if (stateInfo && Array.isArray(stateInfo) && stateInfo.length > 0) {
        stateInfo = stateInfo[0];
        state.powerState = '1';
      }
      state.starCandidates =
        state?.starCandidates &&
        Array.isArray(state.starCandidates) &&
        arrayToHashMap(state.starCandidates, 'first');
      return state;
    });
  data.states = arrayToHashMap(
    data.states && Array.isArray(data.states) ? data.states : [],
    'statePostal',
  );
  data.filteredStates = data.states;
  try {
    if (searches) {
      let filteredStates =
        data?.states && typeof data?.states === 'object'
          ? Object.values(data?.states)
          : [];
      filteredStates = getSortedAndSearchData({
        data: filteredStates,
        searches,
      });
      filteredStates = arrayToHashMap(
        filteredStates && Array.isArray(filteredStates) ? filteredStates : [],
        'statePostal',
      );
      data.filteredStates = filteredStates;
    }
  } catch (error) {
    //
  }
  return usData;
};

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_FILTER_DATA: {
      let filteredStates =
        state?.sortedData?.states &&
        typeof state?.sortedData?.states === 'object'
          ? Object.values(state?.sortedData?.states)
          : [];
      filteredStates = getSortedAndSearchData({
        data: filteredStates,
        searches: action.payload.searches,
      });
      filteredStates = arrayToHashMap(
        filteredStates && Array.isArray(filteredStates) ? filteredStates : [],
        'statePostal',
      );
      return {
        ...state,
        sortedData: {
          ...state.sortedData,
          filteredStates,
        },
      };
    }
    case RECEIVE_ELECTION_DATA: {
      const {
        refreshinterval = 0,
        displaytext = 'Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        result = {},
        inpageminitv,
        inpageminitvus,
        mapEnabled,
        keyStatesEnabled,
        iframeUrl,
        searches,
      } = action.payload;
      if (result?.scores?.data) {
        const sortedData = getSortedViewDataForUS(
          result?.scores?.data,
          states,
          searches,
        );
        return {
          ...state,
          refreshinterval,
          electionData: result?.scores?.data,
          sortedData,
          result,
          displaytext,
          keywords,
          breakingnews,
          states,
          liveblog,
          datasource,
          hideexitheading,
          path,
          shareTitle,
          inpageminitv,
          inpageminitvus,
          mapEnabled,
          keyStatesEnabled,
          iframeUrl,
        };
      }
      return { ...state };
    }
    case RECEIVE_ELECTION_RESULT_DATA: {
      const {
        refreshinterval = 0,
        exitpoll = {},
        displaytext = 'Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        result = {},
        common = false,
      } = action.payload;
      let sortedData = null;
      if (common) {
        sortedData = getSortedViewDataForStates(result?.data, states);
      } else {
        sortedData = getSortedViewDataForSingleState(result?.data, states);
      }
      return {
        ...state,
        refreshinterval,
        electionData: result?.data,
        starCandidateData: result?.data,
        sortedData,
        isExitPoll: false,
        exitpoll,
        result,
        displaytext,
        keywords,
        breakingnews,
        states,
        liveblog,
        datasource,
        hideexitheading,
        path,
        shareTitle,
      };
    }
    case HANDLE_ELECTION_DATA_ERROR: {
      return {
        ...state,
        electionData: {},
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
